export function normalizePropertyTypeValue(value) {
  if (value === null || value === undefined || value === '') {
    return [];
  }

  if (Array.isArray(value)) {
    return [
      ...new Set(value.filter(Boolean).map((type) => String(type).trim())),
    ].filter(Boolean);
  }

  if (typeof value === 'string') {
    return [
      ...new Set(value.split(',').map((type) => type.trim()).filter(Boolean)),
    ];
  }

  return [];
}

export function getDefaultPropertyTypeFilters(
  enablePrivateHallsFilter,
  includeSpareRooms = false
) {
  const defaults = ['house', 'apartment'];

  if (enablePrivateHallsFilter) {
    defaults.push('private-halls');
  }

  // Only blended results can list spare rooms alongside the other types.
  if (includeSpareRooms) {
    defaults.push('spare-rooms');
  }

  return defaults;
}

/**
 * Spare rooms are a mode of their own on a control search: picking them clears every other
 * type, and picking anything else clears them. The filter modals each apply this to a whole
 * selection rather than to a single toggle.
 */
export function applySpareRoomsExclusivity(activeTypes) {
  return activeTypes.includes('spare-rooms')
    ? ['spare-rooms']
    : activeTypes.filter((type) => type !== 'spare-rooms');
}

export function togglePropertyTypeSelection(
  activeTypes,
  typeId,
  blendedSearch = false
) {
  const wasAlreadySelected = activeTypes.includes(typeId);
  let nextActiveTypes = [...activeTypes];

  // Blended results list spare rooms alongside every other type, so it is an ordinary
  // selection there rather than a mode that replaces the rest of the search.
  if (blendedSearch) {
    if (!wasAlreadySelected) {
      return [...nextActiveTypes, typeId];
    }

    const withoutType = nextActiveTypes.filter((type) => type !== typeId);

    // One property type must always remain selected.
    return withoutType.length === 0 ? activeTypes : withoutType;
  }

  if (typeId === 'spare-rooms') {
    // Refuse to clear the only selected type.
    if (wasAlreadySelected) {
      return activeTypes;
    }

    return ['spare-rooms'];
  }

  nextActiveTypes = nextActiveTypes.filter((type) => type !== 'spare-rooms');

  if (wasAlreadySelected) {
    const withoutType = nextActiveTypes.filter((type) => type !== typeId);

    // One property type must always remain selected.
    if (withoutType.length === 0) {
      return activeTypes;
    }

    return withoutType;
  }

  return [...nextActiveTypes, typeId];
}

export function propertyTypeSelectionToValue(activeTypes, multiple = true) {
  if (activeTypes.length === 0) {
    return null;
  }

  if (multiple) {
    return activeTypes.join(',');
  }

  return activeTypes[activeTypes.length - 1];
}
